import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BaseActionService} from '../../service/v2/service/action/baseAction.service';
import {UntypedFormGroup} from '@angular/forms';
import {Payload} from '../../service/payload/payload';

@Component({
  selector: 'app-action-default',
  templateUrl: './action-default.component.html',
  styles: [
  ]
})
export class ActionDefaultComponent<P extends Payload> implements OnInit {

  @Input() service: BaseActionService<P, any>;
  @Input() formGroup: UntypedFormGroup;
  @Input() buildPayload: () => P;
  @Input() buttonLabel = 'Valider';
  @Input() displayButton = true;
  @Input() permission: string;

  @Output() actionSuccessfull = new EventEmitter<any>();
  @Output() actionError = new EventEmitter<any>();

  loading = false;


  constructor() {
  }

  ngOnInit(): void {
  }

  doAction() {
    if (! this.formGroup.valid) {
      throw new Error('Form group is not valid');
    }
    const payload = this.buildPayload ? this.buildPayload() : this.formGroup.value;
    this.loading = true;
    this.service.executeAction(payload)
        .then((result: any) => this.actionSuccessfull?.emit(result))
        .catch((e) => this.actionError?.emit(e))
        .finally(() => this.loading = false);
  }

}
